import { h } from '@stencil/core';
export class ExpandButton {
  constructor() {
    this.isFullscreen = false;
  }
  todoCompletedHandler() {
    this.expandModal.emit();
  }
  render() {
    return (h("pes-icon", { customStyle: { fontSize: '19px' } }, this.isFullscreen ? 'exit_presentation' : 'presentation_mode'));
  }
  static get is() { return "expand-button"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["product-selector-modal.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["product-selector-modal.css"]
    };
  }
  static get properties() {
    return {
      "isFullscreen": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-fullscreen",
        "reflect": false,
        "defaultValue": "false"
      }
    };
  }
  static get events() {
    return [{
        "method": "expandModal",
        "name": "expandModal",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
  static get listeners() {
    return [{
        "name": "click",
        "method": "todoCompletedHandler",
        "target": undefined,
        "capture": true,
        "passive": false
      }];
  }
}
